module.exports = __webpack_public_path__ + "static/media/frick.ac202e25.png";